import React from "react"
import { useSelector } from "react-redux"
import Map from "components/Organisms/map/Map"
import { Locations } from "utils/symbols.utils"
import DispatchDrawer from "./DispatchDrawer"
import DispatchSummary from "./DispatchSummary"
import RoutePreview from "./map/RoutePreview"
import OrdersMapView from "./map/OrdersMapView"
import DispatchMapLegend from "./DispatchMapLegend"
import AllDCLocations from "components/Templates/AllDCLocations"
import useAuth from "hooks/useAuth"

const DispatchMap = () => {
  const isPreviewOpen = useSelector(
    state => (state as any).dispatch.isPreviewOpen
  )
  const auth = useAuth()

  return (
    <div className="w-full h-full vt-dispatch-map">
      <Map
        mapContainerStyle={{
          width: "100%",
          height: "calc(100vh - 128px)",
        }}
        center={Locations.Mohadi}
        zoom={15}
      >
        {isPreviewOpen ? <RoutePreview /> : <OrdersMapView />}
        <AllDCLocations variables={{ pocId: auth.user.id }} />
      </Map>
      <DispatchMapLegend />
      <DispatchDrawer />
      <DispatchSummary />
    </div>
  )
}

export default DispatchMap
